var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47, _tspan48, _tspan49;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35cm",
    height: "34cm",
    viewBox: "2199 419 683 662",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2200,
    y: 420,
    width: 680,
    height: 660
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2200,
    y: 420,
    width: 680,
    height: 660
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2240,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2240,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2280,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2280,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2320,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2320,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2360,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2360,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2400,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2400,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2440,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2440,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2480,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2480,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2520,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2520,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2260,
    y: 525.875
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 2260,
    y: 525.875
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2300,
    y: 525.875
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 2300,
    y: 525.875
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2340,
    y: 525.875
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 2340,
    y: 525.875
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2380,
    y: 525.875
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 2380,
    y: 525.875
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2420,
    y: 525.875
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 2420,
    y: 525.875
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2460,
    y: 525.875
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 2460,
    y: 525.875
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2500,
    y: 525.875
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 2500,
    y: 525.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2540,
    y: 525.875
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 2540,
    y: 525.875
  }, "0"))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2440,
    y1: 600,
    x2: 2440,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2560,
    y1: 600,
    x2: 2560,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2440,
    y1: 620,
    x2: 2560,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2500,
    y1: 620,
    x2: 2500,
    y2: 660
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2500,
    y1: 660,
    x2: 2589,
    y2: 660
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2589,665 2599,660 2589,655 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "2589,665 2599,660 2589,655 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 665.875
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 665.875
  }, "Couleur du bord"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2620,
    y: 740,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2620,
    y: 740,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2660,
    y: 740,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2660,
    y: 740,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2700,
    y: 740,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2700,
    y: 740,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2620,
    y: 780,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2620,
    y: 780,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2660,
    y: 780,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2660,
    y: 780,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2700,
    y: 780,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2700,
    y: 780,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2620,
    y: 820,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2620,
    y: 820,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2660,
    y: 820,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2660,
    y: 820,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2700,
    y: 820,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2700,
    y: 820,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2620,
    y: 860,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2620,
    y: 860,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2660,
    y: 860,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2660,
    y: 860,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2700,
    y: 860,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2700,
    y: 860,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2620,
    y: 900,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2620,
    y: 900,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2660,
    y: 900,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2660,
    y: 900,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2700,
    y: 900,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2700,
    y: 900,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2620,
    y: 940,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2620,
    y: 940,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2660,
    y: 940,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2660,
    y: 940,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2700,
    y: 940,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2700,
    y: 940,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2620,
    y: 980,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2620,
    y: 980,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2660,
    y: 980,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2660,
    y: 980,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2700,
    y: 980,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2700,
    y: 980,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2620,
    y: 1020,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2620,
    y: 1020,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2660,
    y: 1020,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2660,
    y: 1020,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2700,
    y: 1020,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x: 2700,
    y: 1020,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2760,
    y: 765.875
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 2760,
    y: 765.875
  }, "Noir"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2760,
    y: 805.875
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 2760,
    y: 805.875
  }, "Rouge"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2760,
    y: 885.875
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 2760,
    y: 885.875
  }, "Bleu"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2760,
    y: 845.875
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 2760,
    y: 845.875
  }, "Vert"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2760,
    y: 925.875
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 2760,
    y: 925.875
  }, "Jaune"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2760,
    y: 1005.88
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 2760,
    y: 1005.88
  }, "Magenta"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2760,
    y: 965.875
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 2760,
    y: 965.875
  }, "Cyan"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2760,
    y: 1045.88
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 2760,
    y: 1045.88
  }, "Blanc"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2640,
    y: 765.875
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 2640,
    y: 765.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 765.875
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 765.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2720,
    y: 765.875
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 2720,
    y: 765.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2640,
    y: 805.875
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 2640,
    y: 805.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 805.875
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 805.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2720,
    y: 805.875
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 2720,
    y: 805.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2720,
    y: 725.875
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 2720,
    y: 725.875
  }, "R"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 725.875
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 725.875
  }, "V"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2640,
    y: 725.875
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 2640,
    y: 725.875
  }, "B"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2640,
    y: 845.875
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 2640,
    y: 845.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 845.875
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 845.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2720,
    y: 845.875
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 2720,
    y: 845.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 885.875
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 885.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2640,
    y: 885.875
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 2640,
    y: 885.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2720,
    y: 885.875
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 2720,
    y: 885.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 925.875
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 925.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2720,
    y: 925.875
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 2720,
    y: 925.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2640,
    y: 925.875
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 2640,
    y: 925.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2640,
    y: 965.875
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 2640,
    y: 965.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 965.875
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 965.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2720,
    y: 965.875
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 2720,
    y: 965.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2640,
    y: 1005.88
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 2640,
    y: 1005.88
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 1005.88
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 1005.88
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2720,
    y: 1005.88
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 2720,
    y: 1005.88
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2640,
    y: 1045.88
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 2640,
    y: 1045.88
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2680,
    y: 1045.88
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 2680,
    y: 1045.88
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2720,
    y: 1045.88
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 2720,
    y: 1045.88
  }, "1"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2420,
    y1: 580,
    x2: 2420,
    y2: 689
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2415,689 2420,699 2425,689 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "2415,689 2420,699 2425,689 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2400,
    y: 725.875
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 2400,
    y: 725.875
  }, "Incrustation du bord"))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2320,
    y1: 600,
    x2: 2320,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2400,
    y1: 600,
    x2: 2400,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2320,
    y1: 620,
    x2: 2400,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2360,
    y1: 620,
    x2: 2360,
    y2: 800
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2360,
    y1: 800,
    x2: 2389,
    y2: 800
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2389,805 2399,800 2389,795 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "2389,805 2399,800 2389,795 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2420,
    y: 805.875
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 2420,
    y: 805.875
  }, "Type du curseur"))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2300,
    y1: 600,
    x2: 2300,
    y2: 840
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2300,
    y1: 840,
    x2: 2389,
    y2: 840
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2389,845 2399,840 2389,835 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "2389,845 2399,840 2389,835 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2420,
    y: 845.875
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 2420,
    y: 845.875
  }, "Curseur ON / OFF"))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2260,
    y1: 600,
    x2: 2260,
    y2: 880
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2260,
    y1: 880,
    x2: 2389,
    y2: 880
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2389,885 2399,880 2389,875 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "2389,885 2399,880 2389,875 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2420,
    y: 885.875
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 2420,
    y: 885.875
  }, "Double hauteur"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2640,
    y1: 680,
    x2: 2640,
    y2: 689
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2635,689 2640,699 2645,689 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "2635,689 2640,699 2645,689 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2680,
    y1: 680,
    x2: 2680,
    y2: 689
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2675,689 2680,699 2685,689 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "2675,689 2680,699 2685,689 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    x1: 2720,
    y1: 680,
    x2: 2720,
    y2: 689
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2715,689 2720,699 2725,689 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 2,
      stroke: "#000000"
    },
    points: "2715,689 2720,699 2725,689 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2540,
    y: 469.775
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 2540,
    y: 469.775
  }, "MAT"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatBorder);
export default __webpack_public_path__ + "static/media/MAT-border.99c3586264f06abbc5efb0022ae8de11.svg";
export { ForwardRef as ReactComponent };